//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'artist-avatar',
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  methods: {
    handleItemClick: function handleItemClick() {
      this.$emit('item-click', this.content);
    }
  }
};